module.exports = __webpack_public_path__ + "static/media/02_4.8fcc094c.png";